import {FC, useState, useEffect, Fragment} from 'react'
import InfoBox from './InfoBox'
import IndicatorRadio from './IndicatorRadio'

import Api from '../../../../../thesis-and-dissertations/helpers/api'

type Props = {
  dataProps: any
  showInfo: boolean
  handleInput: any
  fieldRefs: any
  assessmentType: string
  errors: any
  defaultValue: any
}

const api = new Api()

const IndicatorAssessmentContent: FC<Props> = ({
  dataProps,
  showInfo,
  handleInput,
  fieldRefs,
  assessmentType,
  errors,
  defaultValue,
}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedData, setSelectedData] = useState([])

  const [selectedIndicators, setSelectedIndicators] = useState<any>({})
  const [calculate, setCalculate] = useState<any>({})
  const [totalValue, setTotalValue] = useState<any>(0)

  useEffect(() => {
    fetchDetailAssessment()
  }, [])

  useEffect(() => {
    const preselected: any = {}
    defaultValue?.details?.forEach((item: any) => {
      preselected[item.aspek_id] = item.nilai
    })
    setSelectedIndicators(preselected)
    setTotalValue(defaultValue?.total_nilai)

    defaultValue?.details?.map((item: any) => {
      handleSelectIndicator(item?.aspek_id, item?.nilai, item?.bobot)
    })
  }, [defaultValue])

  useEffect(() => {
    if (calculate && typeof calculate === 'object') {
      const value = Object.values(calculate).reduce((sum: number, val: any) => sum + Number(val), 0)
      setTotalValue(value.toFixed(2))
      return
    }

    setTotalValue('0.00')
  }, [calculate])

  useEffect(() => {
    handleInput('nilai', selectedIndicators)
  }, [selectedIndicators])

  const calculateRadio = (bobot: number, valueRadio: number) => {
    let totalRadio = 4
    return (bobot / 100) * valueRadio * (100 / totalRadio)
  }

  const fetchDetailAssessment = () => {
    setLoading(true)
    api
      .getDetailAssessment()
      .then((response: any) => {
        const {data} = response.data
        setData(data)
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
        // handleApiError(error, navigate)
      })
  }

  const handleSelectIndicator = (id: string, value: number, bobot: any) => {
    setCalculate((prev: any) => ({
      ...prev,
      [id]: calculateRadio(parseInt(bobot), value),
    }))

    setSelectedIndicators((prev: any) => ({
      ...prev,
      [id]: value,
    }))
  }

  return (
    <div className='card'>
      <div className='p-7 border-bottom'>
        <div className='d-flex align-items-center gap-3'>
          <div className='icon-box px-4 py-2 rounded' style={{backgroundColor: '#EBF3FA'}}>
            <i className='fa fa-solid fa-bars text-dark'></i>
          </div>
          <p className='fs-4 fw-bold'>Indikator Penilaian</p>
        </div>
      </div>
      <div className={`${showInfo ? 'py-8' : 'py-5'}`}>
        <div className='px-8'>
          {showInfo ? (
            <>
              <div className='p-4 bg-light rounded d-flex' style={{border: '1px solid #F4F7FE'}}>
                <i className='bi bi-info-circle-fill text-dark me-3 mt-1'></i>
                <div>
                  <strong>Informasi</strong>
                  <p className='mb-1'>Penilaian:</p>
                  <p className='mb-2'>
                    Setiap aspek dinilai berdasarkan kejelasan dan relevansi sebagai berikut:
                  </p>
                  <ul className='mb-0'>
                    <li>
                      <strong>5 = Sangat baik</strong> – Uraian sangat jelas, relevan, dan didukung
                      data atau argumen kuat.
                    </li>
                    <li>
                      <strong>4 = Baik</strong> – Uraian cukup jelas dan relevan, dengan beberapa
                      ruang untuk perbaikan.
                    </li>
                    <li>
                      <strong>2 = Cukup</strong> – Penjelasan masih kurang rinci atau belum cukup
                      relevan.
                    </li>
                    <li>
                      <strong>1 = Kurang</strong> – Tidak jelas, tidak relevan, atau tanpa dukungan
                      data.
                    </li>
                  </ul>
                </div>
              </div>

              <div className='my-5'>
                <InfoBox assessmentType={assessmentType} />
              </div>
            </>
          ) : null}

          <div ref={fieldRefs?.nilai ?? fieldRefs?.aspek}>
            {(errors?.nilai || errors?.aspek) && (
              <p className='text-danger mb-3 fw-bold'>{errors?.nilai ?? errors?.aspek}</p>
            )}
          </div>

          {data?.map((item: any, index: number) => {
            if (item?.tipe !== assessmentType) return null
            return (
              <IndicatorRadio
                key={index}
                data={item}
                selectedIndicators={selectedIndicators}
                onSelectIndicator={handleSelectIndicator}
              />
            )
          })}

          <div className='border-top'>
            <p className='mt-6 fs-4 fw-bold text-end'>Total Nilai {totalValue}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

const IndicatorAssessmentVerificator: FC<Props> = ({
  dataProps,
  showInfo,
  handleInput,
  fieldRefs,
  assessmentType,
  errors,
  defaultValue,
}) => {
  return (
    <IndicatorAssessmentContent
      dataProps={dataProps}
      showInfo={showInfo}
      handleInput={handleInput}
      fieldRefs={fieldRefs}
      assessmentType={assessmentType}
      errors={errors}
      defaultValue={defaultValue}
    />
  )
}

export default IndicatorAssessmentVerificator
